module.exports = __webpack_public_path__ + "static/multi-870a4e8a84f3aa2f10cb08a406fc4d67.gif";